<template>
  <div>
    <div v-if="totalTantiemes">
      <div class="mb-1">Taux de Présence</div>
      Par rapport au nombre de participants ayant droit de vote :
      <strong>{{ percentPresenceWithVoteRight }} %</strong>
      <div
        v-b-tooltip.hover
        class="btn"
        :title="`Selon le nombre de participants présents, représentés ou ayant voté par correspondance, ${totalPresentOrRepresentedMandatesWithVoteRight} ont droit de vote sur un total de ${totalMandatesWithVoteRight}`"
      >
        <font-awesome-icon icon="info-circle" size="1x" />
      </div>
    </div>
    <div v-if="totalTantiemes && totalPresentOrRepresentedTantiemes" class="mb-1">
      Par rapport aux tantièmes :
      <strong
        >{{
          calculateTotalPresentOrRepresentedTantiemes(
            totalTantiemes,
            totalPresentOrRepresentedTantiemes
          )
        }}
        %</strong
      >
    </div>
    <b-progress v-if="totalTantiemes" show-value :max="totalTantiemes">
      <b-progress-bar
        show-value
        :value="totalPresentOrRepresentedTantiemes"
        :label="`${totalPresentOrRepresentedTantiemes} / ${totalTantiemes} tantièmes`"
      />
    </b-progress>
    <hr />

    <div>
      <appPresenceIndicatorsMenu
        :all-mandates="allMandates"
        :present-mandates="presentMandates"
        :represented-mandates="representedMandates"
        :correspondence-mandates="correspondenceMandates"
        :absent-mandates="absentMandates"
        :video-mandates="videoMandates"
        :represented-video-mandates="representedVideoMandates"
        :meeting-guests="meetingGuests"
        :ignored-correspondence-mandates="ignoredCorrespondenceMandates"
        :presence-button-info-box-text="presenceButtonInfoBoxText"
        @toggleArrivedLeftPressed="toggleArrivedLeftPressed"
      />
    </div>
  </div>
</template>

<script>
import appPresenceIndicatorsMenu from "@/components/snippets/PresenceIndicatorsMenu";
export default {
  components: {
    appPresenceIndicatorsMenu,
  },
  props: {
    meeting: {
      type: Object,
      default: () => {
        return {};
      },
    },
    percentPresence: {
      type: Number,
      default: 0,
    },
    percentPresenceWithVoteRight: {
      type: Number,
      default: 0,
    },
    totalPresentOrRepresentedMandatesWithVoteRight: {
      type: Number,
      default: 0,
    },
    totalMandatesWithVoteRight: {
      type: Number,
      default: 0,
    },
    presentMandates: {
      type: Number,
      default: 0,
    },
    representedMandates: {
      type: Number,
      default: 0,
    },
    videoMandates: {
      type: Number,
      default: 0,
    },
    representedVideoMandates: {
      type: Number,
      default: 0,
    },
    correspondenceMandates: {
      type: Number,
      default: 0,
    },
    ignoredCorrespondenceMandates: {
      type: Number,
      default: 0,
    },
    absentMandates: {
      type: Number,
      default: 0,
    },
    totalTantiemes: {
      type: Number,
      default: 0,
    },
    totalPresentOrRepresentedTantiemes: {
      type: Number,
      default: 0,
    },
    allMandates: {
      type: Number,
      default: 0,
    },
    meetingGuests: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    presenceButtonInfoBoxText() {
      if (this.isPhysicalOnly(this.meeting)) {
        return "Gérez les participants pour la présence physique ainsi que les représentants, les heures de départ/arrivée.";
      } else if (this.isVideoOnly(this.meeting)) {
        return "Gérez les participants pour la présence vidéo ainsi que les représentants, les heures de départ/arrivée.";
      } else if (this.isCorrespondenceOnly(this.meeting)) {
        return "Voir le participants en mode correspondance.";
      } else if (this.isPhysicalAndVideo(this.meeting)) {
        return "Gérez les participants pour la présence physique et vidéo, ainsi que les représentants, les heures de départ/arrivée.";
      } else if (this.isPhysicalAndCorrespondence(this.meeting)) {
        return "Gérez les participants pour la présence physique ainsi que les représentants, les heures de départ/arrivée et la correspondance.";
      } else if (this.isVideoAndCorrespondence(this.meeting)) {
        return "Gérez les participants pour la vidéo ainsi que les représentants, les heures de départ/arrivée et la correspondance.";
      } else if (this.isPhysicalVideoAndCorrespondence(this.meeting)) {
        return "Gérez les participants pour la présence physique et vidéo, ainsi que les représentants, les heures de départ/arrivée et la correspondance.";
      }

      return "";
    },
  },
  methods: {
    toggleArrivedLeftPressed() {
      this.$emit("toggleArrivedLeftPressed");
    },
    isPhysicalOnly(meeting) {
      return (
        meeting.allowed_modalities.physical &&
        !meeting.allowed_modalities.video &&
        !meeting.allowed_modalities.correspondence
      );
    },
    isVideoOnly(meeting) {
      return (
        !meeting.allowed_modalities.physical &&
        meeting.allowed_modalities.video &&
        !meeting.allowed_modalities.correspondence
      );
    },
    isCorrespondenceOnly(meeting) {
      return (
        !meeting.allowed_modalities.physical &&
        !meeting.allowed_modalities.video &&
        meeting.allowed_modalities.correspondence
      );
    },
    isPhysicalAndVideo(meeting) {
      return (
        meeting.allowed_modalities.physical &&
        meeting.allowed_modalities.video &&
        !meeting.allowed_modalities.correspondence
      );
    },
    isPhysicalAndCorrespondence(meeting) {
      return (
        meeting.allowed_modalities.physical &&
        !meeting.allowed_modalities.video &&
        meeting.allowed_modalities.correspondence
      );
    },
    isVideoAndCorrespondence(meeting) {
      return (
        !meeting.allowed_modalities.physical &&
        meeting.allowed_modalities.video &&
        meeting.allowed_modalities.correspondence
      );
    },
    isPhysicalVideoAndCorrespondence(meeting) {
      return (
        meeting.allowed_modalities.physical &&
        meeting.allowed_modalities.video &&
        meeting.allowed_modalities.correspondence
      );
    },
    calculateTotalPresentOrRepresentedTantiemes(
      totalTantiemes,
      totalPresentOrRepresentedTantiemes
    ) {
      return ((totalPresentOrRepresentedTantiemes * 100) / totalTantiemes).toFixed(2);
    },
  },
};
</script>
